export default __webpack_public_path__ + "static/media/subject_master_founder_thumb.028ab51b.png";